// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileBasicFragment } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileBasicFragmentDoc } from '../../../clientProfiles/graphql/ClientProfile.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BeneficiarySubform_ScheduledDistributionFragment = { __typename?: 'ScheduledDistribution', id: string, ageRequirementEnd?: number | null, ageRequirementStart?: number | null, amount?: CurrencyUSD | null, frequency?: Types.ScheduledDistributionFrequency | null, growByInflation: boolean, kind: Types.ScheduledDistributionKind, percentage?: Percent | null, scheduledDistributionNotes?: string | null };

export type BeneficiarySubform_AccessAgeParameterFragment = { __typename?: 'AccessAgeParameter', id: string, ageRequirementEnd?: number | null, ageRequirementStart?: number | null, notes?: string | null };

export type BeneficiarySubform_AccessParameterFragment = { __typename?: 'AccessParameter', id: string, amount?: CurrencyUSD | null, frequency?: Types.AccessParameterFrequency | null, growByInflation: boolean, kind: Types.AccessParameterKind, percentage?: Percent | null, accessAgeParameters: { __typename?: 'AccessAgeParameterConnection', edges?: Array<{ __typename?: 'AccessAgeParameterEdge', node?: (
        { __typename?: 'AccessAgeParameter' }
        & BeneficiarySubform_AccessAgeParameterFragment
      ) | null } | null> | null } };

export type BeneficiarySubform_BeneficiaryFragment = { __typename?: 'Beneficiary', id: string, kind?: Types.BeneficiaryKind | null, level?: Types.BeneficiaryLevel | null, notes?: string | null, scheduledDistributions: { __typename?: 'ScheduledDistributionConnection', edges?: Array<{ __typename?: 'ScheduledDistributionEdge', node?: (
        { __typename?: 'ScheduledDistribution' }
        & BeneficiarySubform_ScheduledDistributionFragment
      ) | null } | null> | null }, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: (
        { __typename?: 'AccessParameter' }
        & BeneficiarySubform_AccessParameterFragment
      ) | null } | null> | null }, powerOfAppointment?: { __typename?: 'BeneficiaryPowerOfAppointment', id: string, power?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOtherNote?: string | null } | null, individual?: { __typename?: 'ClientProfile', id: string } | null, entity?: { __typename?: 'Entity', id: string } | null, organization?: { __typename?: 'ClientOrganization', id: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string } | null };

export type IrrevocableTrustBeneficiariesFragment = { __typename?: 'IrrevocableTrust', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type RevocableTrustBeneficiariesFragment = { __typename?: 'RevocableTrust', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type SlatTrustBeneficiariesFragment = { __typename?: 'SLATTrust', id: string, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type GratTrustBeneficiariesFragment = { __typename?: 'GRATTrust', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type IlitTrustBeneficiariesFragment = { __typename?: 'ILITTrust', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type QprtTrustBeneficiariesFragment = { __typename?: 'QPRTTrust', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type CltTrustBeneficiariesFragment = { __typename?: 'CLTTrust', id: string, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type CrtTrustBeneficiariesFragment = { __typename?: 'CRTTrust', id: string, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type CustodialPersonalAccountBeneficiariesFragment = { __typename?: 'CustodialPersonalAccount', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type QualifiedTuitionPersonalAccountBeneficiariesFragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type RetirementPersonalAccountBeneficiariesFragment = { __typename?: 'RetirementPersonalAccount', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type IndividualPersonalAccountBeneficiariesFragment = { __typename?: 'IndividualPersonalAccount', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type JointPersonalAccountBeneficiariesFragment = { __typename?: 'JointPersonalAccount', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type DafBeneficiariesFragment = { __typename?: 'DonorAdvisedFund', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type PrivateFoundationBeneficiariesFragment = { __typename?: 'PrivateFoundation', id: string, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & BeneficiarySubform_BeneficiaryFragment
  )> | null };

export type BeneficiariesQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type BeneficiariesQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity' } | (
      { __typename?: 'CLTTrust' }
      & CltTrustBeneficiariesFragment
    ) | (
      { __typename?: 'CRTTrust' }
      & CrtTrustBeneficiariesFragment
    ) | (
      { __typename?: 'CustodialPersonalAccount' }
      & CustodialPersonalAccountBeneficiariesFragment
    ) | (
      { __typename?: 'DonorAdvisedFund' }
      & DafBeneficiariesFragment
    ) | { __typename?: 'GPBusinessEntity' } | (
      { __typename?: 'GRATTrust' }
      & GratTrustBeneficiariesFragment
    ) | (
      { __typename?: 'ILITTrust' }
      & IlitTrustBeneficiariesFragment
    ) | (
      { __typename?: 'IndividualPersonalAccount' }
      & IndividualPersonalAccountBeneficiariesFragment
    ) | { __typename?: 'InsurancePersonalAccount' } | (
      { __typename?: 'IrrevocableTrust' }
      & IrrevocableTrustBeneficiariesFragment
    ) | (
      { __typename?: 'JointPersonalAccount' }
      & JointPersonalAccountBeneficiariesFragment
    ) | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | (
      { __typename?: 'PrivateFoundation' }
      & PrivateFoundationBeneficiariesFragment
    ) | (
      { __typename?: 'QPRTTrust' }
      & QprtTrustBeneficiariesFragment
    ) | (
      { __typename?: 'QualifiedTuitionPersonalAccount' }
      & QualifiedTuitionPersonalAccountBeneficiariesFragment
    ) | (
      { __typename?: 'RetirementPersonalAccount' }
      & RetirementPersonalAccountBeneficiariesFragment
    ) | (
      { __typename?: 'RevocableTrust' }
      & RevocableTrustBeneficiariesFragment
    ) | { __typename?: 'SCorpBusinessEntity' } | (
      { __typename?: 'SLATTrust' }
      & SlatTrustBeneficiariesFragment
    ) | { __typename?: 'SoleProprietorshipBusinessEntity' } } | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity', id: string, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & BeneficiarySubform_BeneficiaryFragment
    )> | null } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export type BeneficiariesFormOptionsQueryVariables = Types.Exact<{
  whereAdvisorClients?: Types.InputMaybe<Types.HouseholdWhereInput>;
  whereEntities?: Types.InputMaybe<Types.EntityWhereInput>;
}>;


export type BeneficiariesFormOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, clientProfiles?: Array<(
          { __typename?: 'ClientProfile' }
          & ClientProfileBasicFragment
        )> | null, clientOrganizations?: Array<{ __typename?: 'ClientOrganization', id: string, name: string }> | null, testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string, createdFromEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } } | null } | null> | null } } | null } | null> | null }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    Beneficiaries: 'Beneficiaries' as const,
    BeneficiariesFormOptions: 'BeneficiariesFormOptions' as const
  },
  Fragment: {
    BeneficiarySubform_ScheduledDistribution: 'BeneficiarySubform_ScheduledDistribution' as const,
    BeneficiarySubform_AccessAgeParameter: 'BeneficiarySubform_AccessAgeParameter' as const,
    BeneficiarySubform_AccessParameter: 'BeneficiarySubform_AccessParameter' as const,
    BeneficiarySubform_Beneficiary: 'BeneficiarySubform_Beneficiary' as const,
    IrrevocableTrustBeneficiaries: 'IrrevocableTrustBeneficiaries' as const,
    RevocableTrustBeneficiaries: 'RevocableTrustBeneficiaries' as const,
    SLATTrustBeneficiaries: 'SLATTrustBeneficiaries' as const,
    GRATTrustBeneficiaries: 'GRATTrustBeneficiaries' as const,
    ILITTrustBeneficiaries: 'ILITTrustBeneficiaries' as const,
    QPRTTrustBeneficiaries: 'QPRTTrustBeneficiaries' as const,
    CLTTrustBeneficiaries: 'CLTTrustBeneficiaries' as const,
    CRTTrustBeneficiaries: 'CRTTrustBeneficiaries' as const,
    CustodialPersonalAccountBeneficiaries: 'CustodialPersonalAccountBeneficiaries' as const,
    QualifiedTuitionPersonalAccountBeneficiaries: 'QualifiedTuitionPersonalAccountBeneficiaries' as const,
    RetirementPersonalAccountBeneficiaries: 'RetirementPersonalAccountBeneficiaries' as const,
    IndividualPersonalAccountBeneficiaries: 'IndividualPersonalAccountBeneficiaries' as const,
    JointPersonalAccountBeneficiaries: 'JointPersonalAccountBeneficiaries' as const,
    DAFBeneficiaries: 'DAFBeneficiaries' as const,
    PrivateFoundationBeneficiaries: 'PrivateFoundationBeneficiaries' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const BeneficiarySubform_ScheduledDistributionFragmentDoc = gql`
    fragment BeneficiarySubform_ScheduledDistribution on ScheduledDistribution {
  id
  ageRequirementEnd
  ageRequirementStart
  amount
  frequency
  growByInflation
  kind
  percentage
  scheduledDistributionNotes
}
    `;
export const BeneficiarySubform_AccessAgeParameterFragmentDoc = gql`
    fragment BeneficiarySubform_AccessAgeParameter on AccessAgeParameter {
  id
  ageRequirementEnd
  ageRequirementStart
  notes
}
    `;
export const BeneficiarySubform_AccessParameterFragmentDoc = gql`
    fragment BeneficiarySubform_AccessParameter on AccessParameter {
  id
  accessAgeParameters {
    edges {
      node {
        ...BeneficiarySubform_AccessAgeParameter
      }
    }
  }
  amount
  frequency
  growByInflation
  kind
  percentage
}
    ${BeneficiarySubform_AccessAgeParameterFragmentDoc}`;
export const BeneficiarySubform_BeneficiaryFragmentDoc = gql`
    fragment BeneficiarySubform_Beneficiary on Beneficiary {
  id
  kind
  scheduledDistributions {
    edges {
      node {
        ...BeneficiarySubform_ScheduledDistribution
      }
    }
  }
  accessParameters {
    edges {
      node {
        ...BeneficiarySubform_AccessParameter
      }
    }
  }
  powerOfAppointment {
    id
    power
    powerOtherNote
  }
  level
  notes
  individual {
    id
  }
  entity {
    id
  }
  organization {
    id
  }
  testamentaryEntity {
    id
  }
}
    ${BeneficiarySubform_ScheduledDistributionFragmentDoc}
${BeneficiarySubform_AccessParameterFragmentDoc}`;
export const IrrevocableTrustBeneficiariesFragmentDoc = gql`
    fragment IrrevocableTrustBeneficiaries on IrrevocableTrust {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const RevocableTrustBeneficiariesFragmentDoc = gql`
    fragment RevocableTrustBeneficiaries on RevocableTrust {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const SlatTrustBeneficiariesFragmentDoc = gql`
    fragment SLATTrustBeneficiaries on SLATTrust {
  id
  lifetimeBeneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
  remainderBeneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const GratTrustBeneficiariesFragmentDoc = gql`
    fragment GRATTrustBeneficiaries on GRATTrust {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const IlitTrustBeneficiariesFragmentDoc = gql`
    fragment ILITTrustBeneficiaries on ILITTrust {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const QprtTrustBeneficiariesFragmentDoc = gql`
    fragment QPRTTrustBeneficiaries on QPRTTrust {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const CltTrustBeneficiariesFragmentDoc = gql`
    fragment CLTTrustBeneficiaries on CLTTrust {
  id
  lifetimeBeneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
  remainderBeneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const CrtTrustBeneficiariesFragmentDoc = gql`
    fragment CRTTrustBeneficiaries on CRTTrust {
  id
  lifetimeBeneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
  remainderBeneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const CustodialPersonalAccountBeneficiariesFragmentDoc = gql`
    fragment CustodialPersonalAccountBeneficiaries on CustodialPersonalAccount {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const QualifiedTuitionPersonalAccountBeneficiariesFragmentDoc = gql`
    fragment QualifiedTuitionPersonalAccountBeneficiaries on QualifiedTuitionPersonalAccount {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const RetirementPersonalAccountBeneficiariesFragmentDoc = gql`
    fragment RetirementPersonalAccountBeneficiaries on RetirementPersonalAccount {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const IndividualPersonalAccountBeneficiariesFragmentDoc = gql`
    fragment IndividualPersonalAccountBeneficiaries on IndividualPersonalAccount {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const JointPersonalAccountBeneficiariesFragmentDoc = gql`
    fragment JointPersonalAccountBeneficiaries on JointPersonalAccount {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const DafBeneficiariesFragmentDoc = gql`
    fragment DAFBeneficiaries on DonorAdvisedFund {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const PrivateFoundationBeneficiariesFragmentDoc = gql`
    fragment PrivateFoundationBeneficiaries on PrivateFoundation {
  id
  beneficiaries {
    ...BeneficiarySubform_Beneficiary
  }
}
    ${BeneficiarySubform_BeneficiaryFragmentDoc}`;
export const BeneficiariesDocument = gql`
    query Beneficiaries($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Entity {
      id
      subtype {
        ...IrrevocableTrustBeneficiaries
        ...RevocableTrustBeneficiaries
        ...SLATTrustBeneficiaries
        ...GRATTrustBeneficiaries
        ...QPRTTrustBeneficiaries
        ...ILITTrustBeneficiaries
        ...CLTTrustBeneficiaries
        ...CRTTrustBeneficiaries
        ...DAFBeneficiaries
        ...PrivateFoundationBeneficiaries
        ...CustodialPersonalAccountBeneficiaries
        ...QualifiedTuitionPersonalAccountBeneficiaries
        ...RetirementPersonalAccountBeneficiaries
        ...IndividualPersonalAccountBeneficiaries
        ...JointPersonalAccountBeneficiaries
      }
    }
    ... on TestamentaryEntity {
      id
      beneficiaries {
        ...BeneficiarySubform_Beneficiary
      }
    }
  }
}
    ${IrrevocableTrustBeneficiariesFragmentDoc}
${RevocableTrustBeneficiariesFragmentDoc}
${SlatTrustBeneficiariesFragmentDoc}
${GratTrustBeneficiariesFragmentDoc}
${QprtTrustBeneficiariesFragmentDoc}
${IlitTrustBeneficiariesFragmentDoc}
${CltTrustBeneficiariesFragmentDoc}
${CrtTrustBeneficiariesFragmentDoc}
${DafBeneficiariesFragmentDoc}
${PrivateFoundationBeneficiariesFragmentDoc}
${CustodialPersonalAccountBeneficiariesFragmentDoc}
${QualifiedTuitionPersonalAccountBeneficiariesFragmentDoc}
${RetirementPersonalAccountBeneficiariesFragmentDoc}
${IndividualPersonalAccountBeneficiariesFragmentDoc}
${JointPersonalAccountBeneficiariesFragmentDoc}
${BeneficiarySubform_BeneficiaryFragmentDoc}`;

/**
 * __useBeneficiariesQuery__
 *
 * To run a query within a React component, call `useBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeneficiariesQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useBeneficiariesQuery(baseOptions: Apollo.QueryHookOptions<BeneficiariesQuery, BeneficiariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeneficiariesQuery, BeneficiariesQueryVariables>(BeneficiariesDocument, withFetchPolicyContext(options));
      }
export function useBeneficiariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeneficiariesQuery, BeneficiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeneficiariesQuery, BeneficiariesQueryVariables>(BeneficiariesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useBeneficiariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BeneficiariesQuery, BeneficiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BeneficiariesQuery, BeneficiariesQueryVariables>(BeneficiariesDocument, withFetchPolicyContext(options));
        }
export type BeneficiariesQueryHookResult = ReturnType<typeof useBeneficiariesQuery>;
export type BeneficiariesLazyQueryHookResult = ReturnType<typeof useBeneficiariesLazyQuery>;
export type BeneficiariesSuspenseQueryHookResult = ReturnType<typeof useBeneficiariesSuspenseQuery>;
export type BeneficiariesQueryResult = Apollo.QueryResult<BeneficiariesQuery, BeneficiariesQueryVariables>;
export const BeneficiariesFormOptionsDocument = gql`
    query BeneficiariesFormOptions($whereAdvisorClients: HouseholdWhereInput, $whereEntities: EntityWhereInput) {
  households(where: $whereAdvisorClients) {
    edges {
      node {
        id
        clientProfiles {
          ...ClientProfileBasic
        }
        clientOrganizations {
          id
          name
        }
        testamentaryEntities {
          edges {
            node {
              id
              displayName
              createdFromEntities {
                edges {
                  node {
                    id
                    subtype {
                      id
                      displayName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  entities(where: $whereEntities) {
    edges {
      node {
        id
        stage
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    ${ClientProfileBasicFragmentDoc}`;

/**
 * __useBeneficiariesFormOptionsQuery__
 *
 * To run a query within a React component, call `useBeneficiariesFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeneficiariesFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeneficiariesFormOptionsQuery({
 *   variables: {
 *      whereAdvisorClients: // value for 'whereAdvisorClients'
 *      whereEntities: // value for 'whereEntities'
 *   },
 * });
 */
export function useBeneficiariesFormOptionsQuery(baseOptions?: Apollo.QueryHookOptions<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>(BeneficiariesFormOptionsDocument, withFetchPolicyContext(options));
      }
export function useBeneficiariesFormOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>(BeneficiariesFormOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useBeneficiariesFormOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>(BeneficiariesFormOptionsDocument, withFetchPolicyContext(options));
        }
export type BeneficiariesFormOptionsQueryHookResult = ReturnType<typeof useBeneficiariesFormOptionsQuery>;
export type BeneficiariesFormOptionsLazyQueryHookResult = ReturnType<typeof useBeneficiariesFormOptionsLazyQuery>;
export type BeneficiariesFormOptionsSuspenseQueryHookResult = ReturnType<typeof useBeneficiariesFormOptionsSuspenseQuery>;
export type BeneficiariesFormOptionsQueryResult = Apollo.QueryResult<BeneficiariesFormOptionsQuery, BeneficiariesFormOptionsQueryVariables>;